'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('404', {
    templateUrl: '/views/errors/404.html',
    controller: function() {},
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set('Page Not Found - Opencare');
      },
    },
    data: {
      hideNavigation: true,
    },
  });
});
